export enum InstallationPeriod {
  PRE_INSTALLATION = 'PRE_INSTALLATION',
  POST_INSTALLATION = 'POST_INSTALLATION',
  OTHER = 'OTHER'
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/constants/installation-period.ts